/* ==== i18n ==== */
/* Strings the theme injects as window.N30_I18N (see layout/theme.liquid).
   Declared at script scope so every module below can reach them. */
var I18N = (typeof window!=='undefined' && window.N30_I18N) || {};
function TR(k, fb){ var v = I18N[k]; return (v == null || v === '') ? fb : v; }
function TRn(k, fb, n){ return TR(k, fb).replace('{n}', n); }
if(typeof window!=='undefined'){ window.N30_TR = TR; window.N30_TRn = TRn; }

/* ==== cycle.js ==== */
/* 30N — the cycle clock. One source of truth for every counter on the site. */
(function(){
'use strict';
var CFG   = (typeof window!=='undefined' && window.N30_CONFIG) || {};
function _epoch(){
  var v = CFG.epoch, m = v && /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(v).trim());
  if(m) return new Date(+m[1], +m[2]-1, +m[3]);
  return new Date(2027,1,8);
}
var EPOCH = _epoch();                 /* Cycle 01, Night 01 — set in Theme settings > Cycle */
var LEN   = parseInt(CFG.length,10) || 30;   /* nights per cycle, back to back */

function days(a,b){ return Math.floor((b - a) / 86400000); }
function state(now){
  now = now || new Date();
  var d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  var n = days(EPOCH, d);
  if (n < 0) return { pre:true, cycle:0, night:0, until:-n, complete:0 };
  return { pre:false, cycle:Math.floor(n/LEN)+1, night:(n%LEN)+1,
           until:0, complete:Math.floor(n/LEN) };
}
function pad(n){ return ('0'+n).slice(-2); }

/* Render the cycle-aware mark: 30 ticks + the cycle line beneath */
function paintMark(el, s){
  var lit = s.pre ? 0 : s.night;
  var ticks = el.querySelectorAll('.mark i');
  if(!ticks.length) return;
  [].forEach.call(ticks, function(t,i){
    t.classList.toggle('off', el.dataset.live==='1' && i >= lit);
  });
  var lab = el.querySelector('.cyclab');
  if(lab) lab.textContent = s.pre
    ? TR('cycle','CYCLE') + ' 01 · ' + TRn('in_days','IN {n} DAYS', s.until)
    : TR('cycle','CYCLE') + ' ' + pad(s.cycle) + ' · ' + TR('night','NIGHT') + ' ' + pad(s.night);
}

window.N30Cycle = {
  EPOCH:EPOCH, LEN:LEN, state:state, pad:pad, paintMark:paintMark,
  /* the date a given cycle starts */
  startOf:function(c){ var d=new Date(EPOCH); d.setDate(d.getDate()+(c-1)*LEN); return d; },
  label:function(s){ s=s||state(); return s.pre ? TR('cycle','CYCLE')+' 01' : TR('cycle','CYCLE')+' '+pad(s.cycle); }
};

/* auto-wire anything on the page that wants the cycle */
document.addEventListener('DOMContentLoaded', function(){
  var s = state();
  [].forEach.call(document.querySelectorAll('[data-cycle-mark]'), function(el){ paintMark(el, s); });
  [].forEach.call(document.querySelectorAll('[data-cycle-label]'), function(el){
    el.textContent = s.pre ? TR('cycle','CYCLE')+' 01 · '+TRn('in_days','IN {n} DAYS', s.until)
                           : TR('cycle','CYCLE')+' '+pad(s.cycle)+' · '+TR('night','NIGHT')+' '+pad(s.night);
  });
  [].forEach.call(document.querySelectorAll('[data-cycle-num]'), function(el){
    el.textContent = pad(s.pre ? 1 : s.cycle);
  });
  [].forEach.call(document.querySelectorAll('[data-cycle-done]'), function(el){
    el.textContent = pad(s.complete);
  });
});
})();


/* ==== site.js ==== */
/* TR/TRn come from window.N30_TR / window.N30_TRn (cycle.js) */
/* 30N — motion engine + widgets */
(function(){
'use strict';
var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
var $  = function(id){return document.getElementById(id);};
var $$ = function(s,r){return [].slice.call((r||document).querySelectorAll(s));};
window.N30 = {RM:RM,$:$,$$:$$};

/* ── loader + page-in ───────────────────────── */
var ld = $('load');
if(ld){ var lb=ld.querySelector('.lb');
  for(var i=0;i<30;i++){var t=document.createElement('i');t.style.setProperty('--i',i);lb.appendChild(t);} }
function ready(){
  if(document.body.classList.contains('ready')) return;
  document.body.classList.add('ready');
  if(ld) setTimeout(function(){ld.classList.add('done');}, RM?0:240);
}
/* start on DOMContentLoaded, not window.load — images must not gate the reveal */
if(document.readyState!=='loading') ready(); else addEventListener('DOMContentLoaded',ready);
setTimeout(ready,1200);

/* page-out transition on internal links */
$$('a[href]').forEach(function(a){
  var h=a.getAttribute('href');
  if(!h||h[0]==='#'||/^(https?:|mailto:|tel:)/.test(h)||a.target)return;
  a.addEventListener('click',function(e){
    if(e.metaKey||e.ctrlKey||e.shiftKey)return;
    e.preventDefault(); document.body.classList.add('leaving');
    setTimeout(function(){location.href=h;}, RM?0:300);
  });
});

/* ── devices ────────────────────────────────── */
$$('.mark').forEach(function(el){
  if(el.children.length)return;
  for(var i=0;i<30;i++){var t=document.createElement('i');t.style.setProperty('--i',i);el.appendChild(t);}
});
$$('.nb').forEach(function(el){
  if(el.children.length)return;
  for(var i=0;i<20;i++)el.appendChild(document.createElement('i'));
});

/* ── line splitting ─────────────────────────── */
function splitLines(el){
  if(el.dataset.split)return;
  var txt=el.textContent.trim(); if(!txt)return;
  var words=txt.split(/\s+/);
  el.innerHTML=words.map(function(w){return '<span class="w">'+w+'</span>';}).join(' ');
  var spans=$$('.w',el), lines=[], cur=[], top=null;
  spans.forEach(function(s){
    var t=Math.round(s.getBoundingClientRect().top);
    if(top===null)top=t;
    if(Math.abs(t-top)>4){lines.push(cur);cur=[];top=t;}
    cur.push(s.textContent);
  });
  if(cur.length)lines.push(cur);
  el.innerHTML=lines.map(function(l,i){
    return '<span class="ln" style="--l:'+i+'"><span>'+l.join(' ')+'</span></span>';
  }).join('');
  el.dataset.split='1';
}
function doSplit(){ $$('[data-split]').forEach(splitLines); }
if(!RM) doSplit(); else $$('[data-split]').forEach(function(e){e.dataset.split='1';});
var rt; addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(function(){
  $$('[data-split]').forEach(function(e){e.removeAttribute('data-split');
    var ls=$$('.ln>span',e); if(ls.length)e.textContent=ls.map(function(s){return s.textContent;}).join(' ');});
  doSplit(); $$('[data-split]').forEach(function(e){if(inView(e))e.classList.add('in');});
},220);});
function inView(e){var r=e.getBoundingClientRect();return r.top<innerHeight&&r.bottom>0;}

/* ── reveal ─────────────────────────────────── */
var io=new IntersectionObserver(function(es){es.forEach(function(e){
  if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},
  {threshold:.08,rootMargin:'0px 0px -60px 0px'});
$$('.rv,[data-split],.ln').forEach(function(e){io.observe(e);});

/* ── counters ───────────────────────────────── */
var cio=new IntersectionObserver(function(es){es.forEach(function(e){
  if(!e.isIntersecting)return;
  var el=e.target, end=parseFloat(el.dataset.count), suf=el.dataset.suffix||'',
      dec=(el.dataset.count.indexOf('.')>-1)?1:0, t0=null;
  if(RM){el.textContent=end.toFixed(dec)+suf;cio.unobserve(el);return;}
  (function run(ts){if(!t0)t0=ts;var p=Math.min((ts-t0)/1500,1);
    el.textContent=(end*(1-Math.pow(1-p,3))).toFixed(dec)+suf;
    if(p<1)requestAnimationFrame(run);})(0);
  cio.unobserve(el);});},{threshold:.5});
$$('[data-count]').forEach(function(e){cio.observe(e);});

/* ── nav ────────────────────────────────────── */
var nav=document.querySelector('nav'), lastY=0;
addEventListener('scroll',function(){
  var y=scrollY;
  nav.classList.toggle('solid', y>40);
  nav.classList.toggle('hide', y>320 && y>lastY && !document.querySelector('.nav-l.open'));
  lastY=y;
},{passive:true});
var bg=$('burger'), menu=document.querySelector('.nav-l');
if(bg)bg.onclick=function(){bg.classList.toggle('x');menu.classList.toggle('open');
  document.body.style.overflow=menu.classList.contains('open')?'hidden':'';};

/* ── headlight ──────────────────────────────── */
var rr=$$('.rr'), fl=$$('.mark').concat($$('.nm')), sw=document.querySelector('.sweep');
var mx=-9999,my=-9999,tx=-9999,ty=-9999,sX=-9999,sOn=false,nextS=2400,last=0;
addEventListener('pointermove',function(e){tx=e.clientX;ty=e.clientY;},{passive:true});
function loop(ts){
  if(!last)last=ts; var dt=Math.min(ts-last,50); last=ts;
  mx+=(tx-mx)*.16; my+=(ty-my)*.16;
  if(tx>-9000)rr.forEach(function(el){var r=el.getBoundingClientRect();
    el.style.setProperty('--mx',(mx-r.left)+'px');el.style.setProperty('--my',(my-r.top)+'px');});
  if(!RM&&sw){
    if(!sOn){nextS-=dt;if(nextS<=0){sOn=true;sX=-innerWidth*.3;sw.classList.add('live');}}
    else{
      sX+=(innerWidth*1.75)*(dt/2400);
      if(sX>innerWidth*1.35){sOn=false;sw.classList.remove('live');nextS=9500+Math.floor(ts%6500);
        document.documentElement.style.setProperty('--sx','-9999px');
        rr.forEach(function(e){e.style.setProperty('--lx','-9999px');});
        fl.forEach(function(e){e.classList.remove('flare');});
      }else{
        document.documentElement.style.setProperty('--sx',sX+'px');
        rr.forEach(function(e){var r=e.getBoundingClientRect();e.style.setProperty('--lx',(sX-r.left)+'px');});
        fl.forEach(function(e){var r=e.getBoundingClientRect();
          e.classList.toggle('flare',sX>r.left-innerWidth*.12&&sX<r.right+innerWidth*.12&&r.bottom>0&&r.top<innerHeight);});
      }
    }
  }
  requestAnimationFrame(loop);
}
requestAnimationFrame(loop);

/* ── ignition ───────────────────────────────── */
var demo=$('demo');
if(demo){
  var db=$('dbody'),dcap=$('dcap'),bd=$('bd'),bn=$('bn'),lock=null;
  var ign=function(p){p=Math.max(0,Math.min(1,p));db.style.setProperty('--ig',p.toFixed(3));
    var l=p>.5;bd.classList.toggle('a',!l);bn.classList.toggle('a',l);
    dcap.textContent=l?TR('mark_returned','The same mark, returned to source'):TR('mark_unread','The mark is present, and unread');
    dcap.style.color=l?'var(--mid)':'';};
  var os=function(){if(lock!==null)return;var r=demo.getBoundingClientRect();
    ign((innerHeight*.85-r.top)/(innerHeight*.55));};
  bd.onclick=function(){lock=0;ign(0);};bn.onclick=function(){lock=1;ign(1);};
  addEventListener('scroll',os,{passive:true});ign(RM?1:0);os();
}

/* -- night index ------------------------------
   One source of truth. The verdict, the hours and the dust band are computed
   once by the index worker and read here as they are. Nothing on this page
   decides anything: change a threshold in worker.js and the site follows on
   the next read.
   If the worker cannot be reached we show nothing rather than a second
   opinion. A number the dispatch disagrees with costs more than a blank. */
var IX_URL='https://n30-index.throbbing-bird-1ed3.workers.dev/', IX=null;
function pad(n){return ('0'+n).slice(-2);}
function put(id,v,hot){var e=$(id);if(!e)return;e.textContent=v;e.classList.toggle('sig',!!hot);}
function hourAt(j,h){var f=null;if(j)j.hours.forEach(function(x){if(x.hour===h)f=x;});return f;}
function renderIX(){
  var j=IX, box=$('hrs');
  if(box){
    box.innerHTML='';
    if(j)j.hours.forEach(function(x,i){
      var d=document.createElement('div');
      d.className='hh '+x.grade;
      d.innerHTML='<div class="lab d">'+pad(x.hour)+':00</div><div class="t">'+Math.round(x.temp)+'°</div><div class="d"></div>';
      box.appendChild(d);setTimeout(function(){d.classList.add('in');},RM?0:i*70);});
    if($('ixDate'))$('ixDate').textContent=j?new Date(j.date+'T12:00:00').toLocaleDateString(TR('date_locale','en-GB'),{weekday:'short',day:'2-digit',month:'short'}):'—';
    if($('ixWin'))$('ixWin').textContent=!j?'—':(j.window
      ?TR('window_open','Window open')+' · '+pad(j.window.from)+':00 — '+pad(j.window.to)+':00 · '+j.open_hours+' '+TR('hours','hours')
      :TR('window_closed','Window closed tonight'));
  }
  var bw=(j&&j.dust)?TR('d_'+j.dust,{usual:'Usual',high:'High',storm:'Storm'}[j.dust]):'—';
  /* the strip reads two hours out of the night, not the clock. a daytime
     temperature is not information this brand owes anyone. */
  var t20=hourAt(j,20), t22=hourAt(j,22);
  put('sNow',t20?Math.round(t20.temp)+'°':'—',!!t20&&t20.grade==='bad');
  put('s22',t22?Math.round(t22.temp)+'°':'—',!!t22&&t22.grade==='bad');
  put('sPm',bw,!!j&&(j.dust==='high'||j.dust==='storm'));
  put('sWin',j?(j.open_hours?j.open_hours+' '+TR('h','h'):TR('closed','Closed')):'—',!!j&&!j.open_hours);
  var vb=$('ixV');
  if(vb){
    if(!j){vb.className='ixv';$('ixVw').textContent='—';$('ixVr').textContent=TR('ix_wait','Reading the night');return;}
    vb.className='ixv '+j.verdict;
    $('ixVw').textContent=TR('v_'+j.verdict,{ok:'Clear',hard:'Hard',no:'Stay in'}[j.verdict]);
    $('ixVr').textContent=(j.dust?TR('v_dust','Dust')+' '+bw.toLowerCase()+' · ':'')+j.open_hours+' '+TR('v_open','open');
  }
}
if($('hrs')||$('sNow')){
  renderIX();
  fetch(IX_URL).then(function(r){return r.json();}).then(function(j){
    if(!j||!j.hours)return; IX=j; renderIX();}).catch(function(){});
}

/* ── declare card ───────────────────────────── */
if($('bMake')){
  var cm=$('cardMark');
  for(var k=0;k<30;k++)cm.appendChild(document.createElement('i'));
  var hash=function(s){var h=0;for(var i=0;i<s.length;i++)h=(h*31+s.charCodeAt(i))|0;return h;};
  $('bMake').onclick=function(){
    var nm=($('iName').value||'').trim(), ac=($('iAct').value||'').trim();
    $('cardW').textContent = ac ? 'For thirty nights, I will '+ac.replace(/^I will\s*/i,'') : 'For thirty nights, I will…';
    $('cardN').textContent = nm ? nm.toUpperCase()+' · No. '+('00'+(1+Math.abs(hash(nm+ac))%899)).slice(-3) : '—';
    var on = (nm&&ac)?1:0;
    [].forEach.call(cm.children,function(el,i){el.classList.toggle('on',i<on);});
  };
}

/* ── the thirty counter ─────────────────────── */
var tn=$('tn');
if(tn){var tio=new IntersectionObserver(function(es){es.forEach(function(e){
  if(!e.isIntersecting)return;
  if(RM){tn.textContent='00';tio.unobserve(e.target);return;}
  var t0=null;(function run(ts){if(!t0)t0=ts;var p=Math.min((ts-t0)/2000,1);
    tn.textContent=p<1?('0'+Math.round(30*(1-Math.pow(1-p,4)))).slice(-2):'00';
    if(p<1)requestAnimationFrame(run);})(0);
  tio.unobserve(e.target);});},{threshold:.6});
  tio.observe(tn.parentNode);}

/* ── cycle bar: night 27 ────────────────────── */
var cm2=$('cm'); if(cm2&&cm2.children[26])cm2.children[26].classList.add('ram');
})();

/* ═══ MOTION — second pass ═══════════════════════ */
(function(){
'use strict';
var RM=matchMedia('(prefers-reduced-motion: reduce)').matches;
var $$=function(s){return [].slice.call(document.querySelectorAll(s));};

/* scroll progress rendered as the thirty ticks */
var pr=document.createElement('div'); pr.className='prog'; pr.setAttribute('aria-hidden','true');
for(var i=0;i<30;i++)pr.appendChild(document.createElement('i'));
document.body.appendChild(pr);
var pt=pr.children;
addEventListener('scroll',function(){
  var h=document.documentElement.scrollHeight-innerHeight;
  var p=h>0?Math.min(scrollY/h,1):0;
  pr.classList.toggle('on',scrollY>120);
  var n=Math.round(p*30);
  for(var i=0;i<30;i++)pt[i].classList.toggle('lit',i<n);
},{passive:true});

/* magnetic buttons */
if(!RM&&matchMedia('(hover:hover)').matches){
  $$('.btn').forEach(function(b){
    b.addEventListener('pointermove',function(e){
      var r=b.getBoundingClientRect();
      b.style.transform='translate('+((e.clientX-r.left-r.width/2)*.16).toFixed(1)+'px,'
                                    +((e.clientY-r.top-r.height/2)*.22).toFixed(1)+'px)';
    });
    b.addEventListener('pointerleave',function(){b.style.transform='';});
  });
}

/* idle breathing on unlit ticks, only while the mark is on screen */
var mio=new IntersectionObserver(function(es){es.forEach(function(e){
  e.target.classList.toggle('idle',e.isIntersecting&&!RM);});},{threshold:.2});
$$('.mark').forEach(function(m){mio.observe(m);});

/* nav mark beats once, shortly after load */
setTimeout(function(){
  var n=document.querySelector('.nm'); if(!n||RM)return;
  n.classList.add('beat'); setTimeout(function(){n.classList.remove('beat');},2400);
},3200);
})();


/* ==== map.js ==== */
/* 30N — Riyadh map. Real coordinates. Density only, never identity. */
(function(){
'use strict';
if(!document.getElementById('rmap'))return;
var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
var $=function(i){return document.getElementById(i);};

/* Real running corridors in Riyadh — [lat,lon] */
function SET(){ return CITY==='jeddah' ? JEDDAH : RIYADH; }
function PL(){ return CITY==='jeddah' ? JPLACES : PLACES; }
/* map labels: translate proper nouns when the locale provides them */
var PMAP=(function(){
  var out={}, raw=TR('places','');
  if(!raw) return out;
  raw.split('|').forEach(function(pair){
    var i=pair.indexOf('='); if(i>0) out[pair.slice(0,i).trim()]=pair.slice(i+1).trim();
  });
  return out;
})();
function PN(name){ return PMAP[name] || name; }
var RIYADH={
 wadi:{n:'Wadi Hanifa',w:.24,p:[[24.7820,46.5730],[24.7660,46.5680],[24.7490,46.5665],[24.7370,46.5740],[24.7220,46.5810],[24.7040,46.5885],[24.6870,46.5940],[24.6660,46.5985],[24.6440,46.6035]]},
 sb:{n:'Sports Boulevard',w:.20,p:[[24.7500,46.5915],[24.7420,46.6180],[24.7355,46.6480],[24.7318,46.6790],[24.7292,46.7100],[24.7268,46.7420],[24.7240,46.7740],[24.7205,46.8040]]},
 dq:{n:'Diplomatic Quarter',w:.11,p:[[24.6900,46.6060],[24.6942,46.6215],[24.6885,46.6335],[24.6748,46.6370],[24.6640,46.6280],[24.6660,46.6110],[24.6790,46.6035],[24.6900,46.6060]]},
 kafd:{n:'KAFD',w:.10,p:[[24.7760,46.6280],[24.7692,46.6412],[24.7602,46.6470],[24.7538,46.6392],[24.7580,46.6270],[24.7680,46.6218],[24.7760,46.6280]]},
 ksp:{n:'King Salman Park',w:.09,p:[[24.7165,46.7060],[24.7148,46.7300],[24.7028,46.7448],[24.6900,46.7345],[24.6922,46.7105],[24.7040,46.7000],[24.7165,46.7060]]},
 malaz:{n:'Al Malaz',w:.09,p:[[24.6725,46.7160],[24.6702,46.7305],[24.6620,46.7402],[24.6540,46.7318],[24.6580,46.7178],[24.6665,46.7118],[24.6725,46.7160]]},
 pnu:{n:'PNU',w:.09,p:[[24.8560,46.7000],[24.8542,46.7222],[24.8440,46.7325],[24.8358,46.7202],[24.8402,46.7018],[24.8500,46.6960],[24.8560,46.7000]]},
 north:{n:'Hittin / Qurtubah',w:.08,p:[[24.8000,46.6400],[24.7962,46.6680],[24.7920,46.7000],[24.7898,46.7320],[24.7880,46.7620]]}
};
var PLACES=[
 ['Diriyah',24.7337,46.5750],['JAX',24.7290,46.5860],['Wadi Hanifa',24.7460,46.5780],
 ['KAFD',24.7648,46.6415],['Riyadh Park',24.7700,46.6060],['Hittin',24.7980,46.6180],
 ['Olaya',24.6940,46.6850],['King Salman Park',24.7020,46.7220],['Al Malaz',24.6650,46.7300],
 ['PNU',24.8480,46.7160],['Qurtubah',24.7980,46.7800],['Sports Blvd',24.7318,46.6790]
];
var JEDDAH={
 corn:{n:'Corniche North',w:.30,p:[[21.6520,39.1020],[21.6280,39.1055],[21.6040,39.1090],[21.5800,39.1130],[21.5560,39.1180]]},
 corns:{n:'Corniche South',w:.22,p:[[21.5560,39.1180],[21.5320,39.1240],[21.5080,39.1330],[21.4860,39.1440],[21.4660,39.1560]]},
 f1:{n:'Corniche Circuit',w:.20,p:[[21.6320,39.1040],[21.6400,39.0990],[21.6480,39.1030],[21.6440,39.1120],[21.6340,39.1130],[21.6300,39.1070],[21.6320,39.1040]]},
 tahlia:{n:'Tahlia',w:.14,p:[[21.5780,39.1450],[21.5820,39.1620],[21.5760,39.1760],[21.5650,39.1700],[21.5660,39.1530],[21.5780,39.1450]]},
 obhur:{n:'Obhur',w:.14,p:[[21.7420,39.0900],[21.7250,39.0960],[21.7080,39.1040],[21.6920,39.1120]]}
};
var JPLACES=[['Corniche',21.6100,39.1100],['Corniche Circuit',21.6400,39.1050],
 ['Al Balad',21.4850,39.1870],['Tahlia',21.5750,39.1600],['Obhur',21.7300,39.0950],
 ['Al Hamra',21.5600,39.1350],['King Abdullah Rd',21.5900,39.1900]];
var CITY=((window.N30_CONFIG||{}).city==='jeddah')?'jeddah':'riyadh';
var CENTER=[24.726,46.672], JCENTER=[21.605,39.135], MAXN=470;

/* after-dark participation curve for Riyadh */
function density(min){
  var h=18+min/60, x=h>=18?h:h+24;
  if(CITY==='jeddah')  /* later start, narrower window — the moist onshore flow only clears near midnight */
    return Math.max(0, .74*Math.exp(-Math.pow((x-23.4)/1.85,2)) + .12*Math.exp(-Math.pow((x-19.4)/0.95,2)));
  return Math.max(0, Math.exp(-Math.pow((x-22.6)/2.35,2)) + .20*Math.exp(-Math.pow((x-19.1)/1.05,2)));
}
function lerp(a,b,t){return a+(b-a)*t;}
function ptOn(p,t){var s=p.length-1,f=t*s,i=Math.min(Math.floor(f),s-1),u=f-i;
  return [lerp(p[i][0],p[i+1][0],u), lerp(p[i][1],p[i+1][1],u)];}

var map=null, canvas=null, ctx=null, L=window.L;
var runners=[], mapT=240, playing=false;

var OFM='https://tiles.openfreemap.org/styles/dark', STYLE=null;
/* fetched before the map is built, never after: a GL layer added once Leaflet
   has finished its layout never gets the first size event and paints nothing
   at all until someone drags it. A visitor who does not touch the map sees a
   black rectangle and leaves. */
var STYLEP=window.fetch?fetch(OFM).then(function(r){return r.json();})
  .then(function(st){STYLE=restyle(st);}).catch(function(){}):null;
/* We rewrite their style before MapLibre ever sees it, rather than patching
   layers after load — no race, and one place to read what the map looks like.
   Two reasons it is not used as shipped:
   1. their roads sit at #181818 on #0C0C0C (1.1:1). At 1:1 the whole map read
      as a black rectangle. Majors go to 3.3:1, minors to 2.3:1 — visible, and
      still quiet enough that the sodium heat stays the brightest thing on it.
   2. every symbol layer is dropped. We set our own place names in mono, and
      MapLibre renders Arabic labels reversed without an RTL plugin we do not
      want to load. */
function restyle(st){
  st.layers=st.layers.filter(function(l){return l.type!=='symbol';});
  st.layers.forEach(function(l){
    var id=l.id, p=l.paint||(l.paint={});
    if(l.type==='background'){p['background-color']='#0A0A0A';return;}
    if(l.type==='line'){
      var c=null;
      /* casing first: their majors are an outline plus a dark inner fill. Keep
         that — a thin lit edge reads as an engineering drawing, a solid stroke
         reads as a road atlas and drowns the heat. */
      if(/casing/.test(id))c='#39424A';
      else if(/motorway|trunk|major|primary/.test(id))c='#15181A';
      else if(/secondary|tertiary|minor|street|road/.test(id))c='#2E363B';
      else if(/path|rail|track|taxiway|runway|pier/.test(id))c='#1B1F22';
      else if(/water/.test(id))c='#18222C';
      if(c){p['line-color']=c;if(p['line-opacity']==null)p['line-opacity']=1;}
      return;
    }
    if(l.type==='fill'){
      if(/^water/.test(id))p['fill-color']='#18222C';
      else if(/park|wood|grass|landcover/.test(id))p['fill-color']='#141719';
      else if(/building/.test(id))p['fill-color']='#0F1113';
      else if(/residential|landuse/.test(id))p['fill-color']='#0C0D0E';
    }
  });
  return st;
}

function boot(){
  if(L && window.maplibregl && L.maplibreGL && STYLEP) STYLEP.then(build);
  else build();
}

/* The GL canvas mounts but is never sized: the bridge resizes it only on
   Leaflet's 'resize', and invalidateSize() fires nothing when the measured
   size did not change. Without this the basemap stays black on first paint
   and again after every city switch — the streets came back only when a
   visitor happened to drag the map. Both nudges on purpose: map.fire reaches
   the bridge, the window event reaches MapLibre's own listener. Verified live
   on both cities, 27 Aug 2026. */
function nudge(){
  if(!map)return;
  setTimeout(function(){
    map.invalidateSize();
    map.fire('resize');
    try{window.dispatchEvent(new Event('resize'));}
    catch(e){var ev=document.createEvent('Event');ev.initEvent('resize',true,true);window.dispatchEvent(ev);}
  },0);
}

function build(){
  if(L){
    map=L.map('rmap',{center:CENTER,zoom:11,zoomControl:true,attributionControl:true,
      scrollWheelZoom:false,minZoom:10,maxZoom:15});
    /* base map: OpenFreeMap. Free, no key, no limits, commercial use allowed.
       CARTO began watermarking their keyless tiles on 27 Aug 2026, and their
       free key is non-commercial — which a store that sells is not.
       OpenFreeMap serves vector tiles, so MapLibre draws them under Leaflet.
       If either script fails we draw on black: the corridors are the content,
       the streets are context. */
    if(window.maplibregl && L.maplibreGL){
      map.attributionControl.addAttribution(
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' +
        ' &middot; <a href="https://openfreemap.org">OpenFreeMap</a>');
      L.maplibreGL({style:STYLE||OFM}).addTo(map);
      nudge();
    }
    /* corridors as real polylines */
    Object.keys(SET()).forEach(function(k){
      L.polyline(SET()[k].p,{color:'#2E363B',weight:3,opacity:.9,lineCap:'round'}).addTo(map);
    });
    PL().forEach(function(p){
      L.marker([p[1],p[2]],{icon:L.divIcon({className:'',html:
        '<div style="display:flex;align-items:center;gap:6px;transform:translate(-3px,-4px)">'+
        '<span style="width:5px;height:5px;background:#3A4247;display:block;border-radius:50%"></span>'+
        '<span style="font:400 9.5px/1 \'JetBrains Mono\',monospace;letter-spacing:.14em;'+
        'text-transform:uppercase;color:#5A6267;white-space:nowrap">'+PN(p[0])+'</span></div>',
        iconSize:[0,0]})}).addTo(map);
    });
    var pane=map.createPane('runners'); pane.style.zIndex=650; pane.style.pointerEvents='none';
    canvas=document.createElement('canvas'); pane.appendChild(canvas);
    ctx=canvas.getContext('2d');
    map.on('move zoom resize viewreset',sizeCanvas);
    sizeCanvas();
  } else {
    /* Leaflet unavailable — draw the corridors on a bare canvas so the module still works */
    var host=$('rmap'); host.style.position='relative';
    canvas=document.createElement('canvas'); host.appendChild(canvas); ctx=canvas.getContext('2d');
    sizeCanvas();
    addEventListener('resize',sizeCanvas);
  }
  seed(); paint(); requestAnimationFrame(frame); buildDens(); goLive();
}

function sizeCanvas(){
  var host=$('rmap'), w=host.clientWidth, h=host.clientHeight, dpr=Math.min(devicePixelRatio||1,2);
  canvas.width=w*dpr; canvas.height=h*dpr;
  canvas.style.width=w+'px'; canvas.style.height=h+'px';
  canvas.style.position='absolute'; canvas.style.left='0'; canvas.style.top='0';
  if(map){var tl=map.containerPointToLayerPoint([0,0]);L.DomUtil.setPosition(canvas,tl);}
  ctx.setTransform(dpr,0,0,dpr,0,0);
}
/* project lat/lon -> screen px */
function proj(lat,lon){
  if(map){var p=map.latLngToContainerPoint([lat,lon]);return [p.x,p.y];}
  var host=$('rmap'),w=host.clientWidth,h=host.clientHeight;
  var B = CITY==='jeddah' ? [39.06,39.22,21.78,21.45] : [46.53,46.83,24.88,24.60];
  var x=(lon-B[0])/(B[1]-B[0])*w, y=(B[2]-lat)/(B[2]-B[3])*h;
  return [x,y];
}

function seed(){
  runners=[];
  Object.keys(SET()).forEach(function(k){
    var c=SET()[k], n=Math.round(MAXN*c.w);
    for(var i=0;i<n;i++){
      runners.push({p:c.p,t:Math.random(),v:(Math.random()*.5+.35)/1000,
        dir:Math.random()<.5?1:-1, jx:(Math.random()-.5)*.0032, jy:(Math.random()-.5)*.0032,
        big:Math.random()<.10, hash:Math.random(), k:k});
    }
  });
}

function paint(){
  if(!ctx)return;
  var host=$('rmap'), w=host.clientWidth, h=host.clientHeight;
  ctx.clearRect(0,0,w,h);
  var d=density(mapT), shown=0;

  if(!map){ /* fallback: draw corridors ourselves */
    ctx.strokeStyle='#22292E'; ctx.lineWidth=3; ctx.lineCap='round';
    Object.keys(SET()).forEach(function(k){
      var p=SET()[k].p; ctx.beginPath();
      p.forEach(function(pt,i){var q=proj(pt[0],pt[1]); i?ctx.lineTo(q[0],q[1]):ctx.moveTo(q[0],q[1]);});
      ctx.stroke();
    });
    ctx.fillStyle='#5A6267'; ctx.font='400 9.5px "JetBrains Mono",monospace';
    PL().forEach(function(p){var q=proj(p[1],p[2]);
      ctx.fillRect(q[0]-2,q[1]-2,4,4); ctx.fillText(PN(p[0]).toUpperCase(),q[0]+9,q[1]+3);});
  }

  /* density bloom */
  Object.keys(SET()).forEach(function(k){
    var c=SET()[k], m=ptOn(c.p,.5), q=proj(m[0],m[1]);
    var r=(38+c.w*150)*(map?Math.pow(2,map.getZoom()-11):1);
    var g=ctx.createRadialGradient(q[0],q[1],0,q[0],q[1],r);
    g.addColorStop(0,'rgba(255,59,48,'+(d*.30).toFixed(3)+')');
    g.addColorStop(1,'rgba(255,59,48,0)');
    ctx.fillStyle=g; ctx.beginPath(); ctx.arc(q[0],q[1],r,0,6.2832); ctx.fill();
  });

  /* runners */
  runners.forEach(function(r){
    if(r.hash>=d)return;
    var pt=ptOn(r.p,r.t), q=proj(pt[0]+r.jy,pt[1]+r.jx);
    if(q[0]<-40||q[0]>w+40||q[1]<-40||q[1]>h+40){shown++;return;}
    shown++;
    ctx.fillStyle=r.big?'rgba(255,59,48,1)':'rgba(255,59,48,.82)';
    ctx.beginPath(); ctx.arc(q[0],q[1],r.big?2.9:1.9,0,6.2832); ctx.fill();
    if(r.big){ctx.fillStyle='rgba(255,59,48,.22)';ctx.beginPath();ctx.arc(q[0],q[1],7,0,6.2832);ctx.fill();}
  });

  if($('mapN'))$('mapN').textContent=shown;
  if($('navCount'))$('navCount').textContent=shown+' '+(window.N30_TR?window.N30_TR('running','running'):'running');
  var hh=Math.floor(18+mapT/60)%24;
  if($('clk'))$('clk').textContent=pad(hh)+':'+pad(Math.floor((mapT%60)/5)*5);
  var dens=$('dens');
  if(dens)[].forEach.call(dens.children,function(el,i){el.classList.toggle('now',i===Math.round(mapT/60));});
}
function pad(n){return ('0'+n).slice(-2);}

var mlast=0;
function frame(ts){
  var dt=Math.min(ts-mlast,60); mlast=ts;
  if(!RM){
    runners.forEach(function(r){
      r.t+=r.v*dt*r.dir*.06;
      if(r.t>1){r.t=1;r.dir=-1;} if(r.t<0){r.t=0;r.dir=1;}
    });
  }
  if(playing){mapT+=dt*.075; if(mapT>480)mapT=0; if($('scr'))$('scr').value=mapT;}
  paint();
  requestAnimationFrame(frame);
}

function buildDens(){
  var box=$('dens'); if(!box)return; var html='';
  for(var i=0;i<=8;i++)
    html+='<div><div class="bar"><span style="height:'+Math.round(density(i*60)*30)+'px"></span></div>'+
          '<div class="lab d">'+pad((18+i)%24)+':00</div></div>';
  box.innerHTML=html;
}
function goLive(){
  playing=false;
  var b=$('bPlay'); if(b)b.classList.remove('a');
  var l=$('bLive'); if(l)l.classList.add('a');
  var n=new Date(), h=n.getHours()+n.getMinutes()/60;
  var x = h>=18 ? h-18 : (h<=2 ? h+6 : (h<10 ? 8 : 0));
  mapT=Math.max(0,Math.min(480,x*60));
  if($('scr'))$('scr').value=mapT;
}
if($('scr'))$('scr').addEventListener('input',function(){
  mapT=+this.value; playing=false;
  ['bPlay','bLive'].forEach(function(i){if($(i))$(i).classList.remove('a');});
});
if($('bPlay'))$('bPlay').onclick=function(){playing=!playing;this.classList.toggle('a',playing);
  if($('bLive'))$('bLive').classList.remove('a');};
if($('bLive'))$('bLive').onclick=goLive;

window.N30Map = { setCity:function(c){
  if(c===CITY)return; CITY=c;
  /* keep the basemap. It is not a TileLayer — the MapLibre bridge is a plain
     L.Layer — so a bare instanceof TileLayer test strips the streets on the
     first city switch and never puts them back. */
  if(map){ map.eachLayer(function(l){
      if(l instanceof L.TileLayer) return;
      if(L.MaplibreGL && l instanceof L.MaplibreGL) return;
      if(typeof l.getMaplibreMap === 'function') return;
      map.removeLayer(l); });
    Object.keys(SET()).forEach(function(k){ L.polyline(SET()[k].p,{color:'#2E363B',weight:3,opacity:.9,lineCap:'round'}).addTo(map); });
    PL().forEach(function(p){ L.marker([p[1],p[2]],{icon:L.divIcon({className:'',html:
      '<div style="display:flex;align-items:center;gap:6px;transform:translate(-3px,-4px)">'+
      '<span style="width:5px;height:5px;background:#3A4247;display:block;border-radius:50%"></span>'+
      '<span style="font:400 9.5px/1 \'JetBrains Mono\',monospace;letter-spacing:.14em;'+
      'text-transform:uppercase;color:#5A6267;white-space:nowrap">'+p[0]+'</span></div>',
      iconSize:[0,0]})}).addTo(map); });
    map.setView(CITY==='jeddah'?JCENTER:CENTER, 11);
    nudge();          /* the new city needs the same first paint as the old one */
  }
  seed(); buildDens(); paint();
}};
if(document.readyState!=='loading')boot(); else addEventListener('DOMContentLoaded',boot);
})();


/* ==== member.js ==== */
/* 30N — the member record, the daily card, and the playlist options */
(function(){
'use strict';
if(!document.getElementById('grid30'))return;
var C = window.N30Cycle, $ = function(i){return document.getElementById(i);};
var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ── state ─────────────────────────────────────
   In-memory only. Production is server-backed, because attendance is
   verified by a person at the session — not self-reported in a browser. */
var S = { name:'', act:'', done:{}, no:0 };
var st = C.state();
var CUR = st.pre ? 0 : st.night;

/* ── the thirty ────────────────────────────── */
var grid = $('grid30');
for(var i=1;i<=30;i++){
  var d=document.createElement('div');
  d.className='nite'+(i===27?' rest':'')+(i===CUR?' today':'')+(i>CUR&&CUR>0?' future':(CUR===0?' future':''));
  d.dataset.n=i;
  d.innerHTML='<span>'+C.pad(i)+'</span>';
  grid.appendChild(d);
}
grid.addEventListener('click',function(e){
  var el=e.target.closest('.nite'); if(!el)return;
  var n=+el.dataset.n;
  if(n===27){ toast(TR('night_27','Night 27 — the city rests. Nothing to mark.')); return; }
  if(CUR===0){ toast(TR('not_started','Cycle 01 has not started. Night 01 is 8 February 2027.')); return; }
  if(n>CUR){ toast(TR('not_yet','That night has not happened yet.')); return; }
  S.done[n] = !S.done[n];
  el.classList.toggle('done',S.done[n]);
  if(S.done[n]&&!RM){ el.classList.add('pulse'); setTimeout(function(){el.classList.remove('pulse');},700); }
  refresh();
});

function count(){ var c=0; for(var k in S.done) if(S.done[k]) c++; return c; }
function streak(){
  var s=0; for(var i=CUR;i>=1;i--){ if(i===27)continue; if(S.done[i])s++; else break; } return s;
}
function refresh(){
  var c=count();
  $('mDone').textContent=C.pad(c);
  $('mStreak').textContent=C.pad(streak());
  $('mLeft').textContent=C.pad(Math.max(0,29-c));   /* 29 runnable nights: 30 minus the rest night */
  draw();
}

/* ── the daily card ────────────────────────── */
var cv=$('shareCanvas'), ctx=cv.getContext('2d'), MODE='night';
function size(){
  var w=cv.clientWidth||360, h=cv.clientHeight||450, r=Math.min(devicePixelRatio||1,2);
  cv.width=w*r; cv.height=h*r; ctx.setTransform(r,0,0,r,0,0); return [w,h];
}
function draw(){
  var wh=size(), W=wh[0], H=wh[1];
  ctx.fillStyle='#000'; ctx.fillRect(0,0,W,H);
  var pad=Math.round(W*0.085), c=count();

  /* the thirty ticks across the top */
  var tw=(W-pad*2), tick=tw/30*0.62, gap=tw/30*0.38, x=pad;
  for(var i=0;i<30;i++){
    var on = MODE==='cycle' ? i < st.complete*2.5 : S.done[i+1];
    ctx.fillStyle = on ? '#FFFFFF' : 'rgba(250,250,250,.10)';
    ctx.fillRect(x, pad, tick, Math.round(H*0.035));
    x += tick+gap;
  }

  ctx.textBaseline='alphabetic';
  if(MODE==='night'){
    ctx.fillStyle='#FFFFFF';
    ctx.font='200 '+Math.round(W*0.30)+'px "JetBrains Mono",monospace';
    ctx.fillText(C.pad(c), pad, Math.round(H*0.40));
    var mw=ctx.measureText(C.pad(c)).width;
    ctx.fillStyle='#26292C';
    ctx.fillText('/30', pad+mw, Math.round(H*0.40));
    ctx.fillStyle='#767C81';
    ctx.font='400 '+Math.round(W*0.032)+'px "JetBrains Mono",monospace';
    ctx.fillText(TR('nights_completed','NIGHTS COMPLETED'), pad, Math.round(H*0.47));
  } else if(MODE==='cycle'){
    ctx.fillStyle='#FFFFFF';
    ctx.font='200 '+Math.round(W*0.30)+'px "JetBrains Mono",monospace';
    ctx.fillText(C.pad(st.pre?1:st.cycle), pad, Math.round(H*0.40));
    ctx.fillStyle='#767C81';
    ctx.font='400 '+Math.round(W*0.032)+'px "JetBrains Mono",monospace';
    ctx.fillText(TR('cycle_word','CYCLE'), pad, Math.round(H*0.47));
  } else { /* declare */
    ctx.fillStyle='#FFFFFF';
    ctx.font='200 '+Math.round(W*0.19)+'px "JetBrains Mono",monospace';
    ctx.fillText('00', pad, Math.round(H*0.34));
    var m2=ctx.measureText('00').width;
    ctx.fillStyle='#26292C'; ctx.fillText('/30', pad+m2, Math.round(H*0.34));
  }

  /* the commitment line, wrapped */
  var line = S.act ? 'For thirty nights, I will '+S.act.replace(/^I will\s*/i,'')
                   : 'For thirty nights, I will…';
  ctx.fillStyle='#FAFAFA';
  ctx.font='500 '+Math.round(W*0.058)+'px Inter,system-ui,sans-serif';
  var words=line.split(' '), ln='', y=Math.round(H*(MODE==='declare'?0.50:0.60)), max=W-pad*2;
  for(var w2=0;w2<words.length;w2++){
    var t=ln+words[w2]+' ';
    if(ctx.measureText(t).width>max && ln){ ctx.fillText(ln,pad,y); ln=words[w2]+' '; y+=Math.round(W*0.075); }
    else ln=t;
  }
  ctx.fillText(ln,pad,y);

  /* footer rule + meta */
  ctx.strokeStyle='#1E2124'; ctx.lineWidth=1;
  ctx.beginPath(); ctx.moveTo(pad,H-pad*1.9); ctx.lineTo(W-pad,H-pad*1.9); ctx.stroke();
  ctx.fillStyle='#4A5155';
  ctx.font='400 '+Math.round(W*0.028)+'px "JetBrains Mono",monospace';
  var left = (S.name? S.name.toUpperCase()+' · ' : '') + TR('no','NO.')+' '+('00'+(S.no||0)).slice(-3);
  ctx.fillText(left, pad, H-pad*1.15);
  var right='30N · '+ TR('cycle','CYCLE') + ' ' + (st.pre?'01':C.pad(st.cycle));
  ctx.fillText(right, W-pad-ctx.measureText(right).width, H-pad*1.15);
  ctx.fillStyle='#26292C';
  ctx.font='400 '+Math.round(W*0.026)+'px "JetBrains Mono",monospace';
  ctx.fillText('24°42′N 46°40′E · '+TR('city','RIYADH'), pad, H-pad*0.5);
}

/* mode switch */
[].forEach.call(document.querySelectorAll('#modeSeg button'),function(b){
  b.onclick=function(){
    [].forEach.call(document.querySelectorAll('#modeSeg button'),function(x){x.classList.remove('a');});
    b.classList.add('a'); MODE=b.dataset.mode; draw();
  };
});

/* inputs */
function hash(s){var h=0;for(var i=0;i<s.length;i++)h=(h*31+s.charCodeAt(i))|0;return h;}
function sync(){
  S.name=($('mName').value||'').trim();
  S.act =($('mAct').value||'').trim();
  S.no  = (S.name||S.act) ? 1+Math.abs(hash(S.name+S.act))%899 : 0;
  draw();
}
$('mName').addEventListener('input',sync);
$('mAct').addEventListener('input',sync);

/* download / copy */
$('btnSave').onclick=function(){
  try{
    var a=document.createElement('a');
    a.download='30N-'+(st.pre?'cycle01':'cycle'+C.pad(st.cycle))+'-'+C.pad(count())+'of30.png';
    a.href=cv.toDataURL('image/png'); a.click();
    toast(TR('card_saved','Card saved.'));
  }catch(e){ toast(TR('save_blocked','Saving is blocked in this preview — it works on the live site.')); }
};
$('btnCopy').onclick=function(){
  var t=(S.act? TR('for_thirty','For thirty nights, I will ')+S.act.replace(/^I will\s*/i,'')+'. ' : '')
      + C.pad(count())+'/30. '
      + TR('cycle','CYCLE') + ' ' + (st.pre?'01':C.pad(st.cycle))
      + ' · 30nights.sa';
  if(navigator.clipboard&&navigator.clipboard.writeText){
    navigator.clipboard.writeText(t).then(function(){toast(TR('caption_copied','Caption copied.'));},
      function(){toast(TR('copy_blocked','Copy blocked here — works on the live site.'));});
  } else toast(TR('copy_blocked','Copy blocked here — works on the live site.'));
};

/* toast */
var tEl=null,tT=null;
function toast(msg){
  if(!tEl){ tEl=document.createElement('div'); tEl.className='n30toast'; document.body.appendChild(tEl);
    tEl.style.cssText='position:fixed;left:50%;bottom:34px;transform:translateX(-50%) translateY(20px);'+
      'background:#FAFAFA;color:#0A0A0A;font-family:var(--m);font-size:10px;letter-spacing:.14em;'+
      'text-transform:uppercase;padding:13px 20px;z-index:9999;opacity:0;transition:.4s cubic-bezier(.19,1,.22,1);pointer-events:none';
  }
  tEl.textContent=msg;
  requestAnimationFrame(function(){ tEl.style.opacity='1'; tEl.style.transform='translateX(-50%) translateY(0)'; });
  clearTimeout(tT); tT=setTimeout(function(){ tEl.style.opacity='0'; tEl.style.transform='translateX(-50%) translateY(20px)'; },2600);
}

/* ── playlist options ──────────────────────── */
[].forEach.call(document.querySelectorAll('.spotrow'),function(r){
  r.onclick=function(){
    var body=r.nextElementSibling, open=body.classList.contains('open');
    [].forEach.call(document.querySelectorAll('.spotbody'),function(b){b.classList.remove('open');});
    [].forEach.call(document.querySelectorAll('.spotrow'),function(x){x.classList.remove('on');});
    if(!open){ body.classList.add('open'); r.classList.add('on'); }
  };
});

addEventListener('resize',function(){ clearTimeout(window.__rz); window.__rz=setTimeout(draw,160); });
refresh();
setTimeout(draw,400);
})();


/* ==== city segmented control (was inline in map.html) ==== */
(function(){var seg=document.getElementById('citySeg');if(!seg)return;
[].forEach.call(seg.querySelectorAll('button'),function(b){
  b.addEventListener('click',function(){
    [].forEach.call(seg.querySelectorAll('button'),function(x){x.classList.remove('a');});
    b.classList.add('a');
    if(window.N30Map)window.N30Map.setCity(b.dataset.city);
  });
});})();